import React from 'react';
import './MountPage.css';

const MountPage = ({ onClose }) => {
    return (

            <div className="mountpage-container">
            {/* <button className="mountpage-close-button" onClick={onClose}>{'\u00D7'}</button> */}
                <div className="mountpage-content">
                    <p>Crew Page Coming End Q4.</p>
                </div>
            </div>

    );
};

export default MountPage;